import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";

import { IToken } from "src/commonTypes";
export const fetchToken = createAsyncThunk(
    "token/fetchToken",
    () => {
        // Credentials for the upstream access-token exchange are held server-side only
        // (see server.js: POST /api/ibb-access-token) so they never ship in the client bundle.
        return axios
            .post('/api/ibb-access-token')
            .then((response) => response.data)
            .catch((error) => error)
    }
);

const LSToken = JSON.parse(`${localStorage.getItem('token')}`);
const hasLSToken = (LSToken !== null)
const tokenSlice = createSlice({
    name: "ibbToken",
    initialState: {
        status: "idle",
        token: hasLSToken ? LSToken.token : null,
        expires: hasLSToken ? LSToken.expires : null,
        error: {}
    },
    reducers: {
    },
    extraReducers: {
        [fetchToken.pending.type]: (state) => {
            state.status = "loading"
            state.token = ""
            state.expires = ""
            state.error = {}
        },
        [fetchToken.fulfilled.type]: (state, action: PayloadAction<IToken>) => {
                state.status = "success"
                state.token = action.payload.access_token
                state.expires = action.payload.expires_at
                state.error = {}
                const tokenArr = {
                    "token": action.payload.access_token,
                    "expires": action.payload.expires_at
                }
                localStorage.setItem('token', JSON.stringify(tokenArr))
        },
        [fetchToken.rejected.type]: (state, action: PayloadAction<IToken>) => {
            state.status = "error"
            state.token = ""
            state.expires = ""
            state.error = action.payload
        },
    },
});

export default tokenSlice.reducer;